import axios from 'axios'
import {
  INewOwnerFilters,
  INewOwnerDetailUpdateModel,
} from '../models/NewOwners'

const BASE_URL = 'changeofownership/Approval'

export const getChangeOfOwnerships = (body: INewOwnerFilters) =>
  axios.post(BASE_URL, body)

export const getNewOwnerDetails = (approvalId: string) =>
  axios.get(`${BASE_URL}/${approvalId}`, {
    headers: { 'x-api-version': '1.0' },
  })

export const updateNewOwnerStatus = (body: INewOwnerDetailUpdateModel) => {
  axios.put(`${BASE_URL}/${body.approvalId}`, body.updateModel, {
    headers: {
      'x-api-version': '1.0',
    },
  })
}

export const getApproverHandler = (clientId: string) =>
  axios.get(`${BASE_URL}/approvalhandler/${clientId}`, {
    headers: { 'x-api-version': '1.0' },
  })

export const getYearlyApprovals = (clientId: string, year: number) =>
  axios.get(`${BASE_URL}/annual/${clientId}/${String(year)}`, {
    headers: { 'x-api-version': '1.0' },
  })
